import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from 'shared/lib/classNames/classNames';
import { Loader } from 'shared/ui/Loader/Loader';
import cls from './PageLoader.module.scss';
export var PageLoader = function (_a) {
    var className = _a.className, text = _a.text;
    return (_jsx("div", { className: classNames(cls.PageLoader, {}, [className]), children: _jsxs("div", { className: cls.container, children: [_jsx("div", { className: cls.box, children: _jsx(Loader, { className: cls.icon }) }), text
                    && (_jsx("div", { className: cls.text, children: text }))] }) }));
};
